import React from 'react';
import Navigation from '../components/layout/Navigation';
import Footer from '../components/layout/Footer';
import SEO from '../components/SEO';
import HeroSection from '../components/sections/HeroSection';
import CogniaBanner from '../components/sections/CogniaBanner';
import ProblemSection from '../components/sections/ProblemSection';
import SolutionSection from '../components/sections/SolutionSection';
import CogniaSection from '../components/sections/CogniaSection';
import PathwaySection from '../components/sections/PathwaySection';
import OutcomesSection from '../components/sections/OutcomesSection';
import ProofSection from '../components/sections/ProofSection';
import ObjectionSection from '../components/sections/ObjectionSection';
import CTASection from '../components/sections/CTASection';

export default function HomePage() {
  return (
    <div data-testid="home-page" className="min-h-screen">
      <SEO path="/" />
      <Navigation />
      <main>
        <HeroSection />
        <CogniaBanner />
        <ProblemSection />
        <SolutionSection />
        <CogniaSection />
        <PathwaySection />
        <OutcomesSection />
        <ProofSection />
        <ObjectionSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
